module.exports = __webpack_public_path__ + "img/award-4.b13d0b9d.png";